import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'

export class ZoneTypeForm extends Component {

    render() {
        let { zoneType, title, nameInputError } = this.props;

        return (
            typeof zoneType !== 'undefined'
                ?
                < Modal show={this.props.show} >
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup controlId="formNome" validationState={nameInputError}>
                                <ControlLabel>Nome</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={zoneType.name}
                                    placeholder="Introduza o Nome"
                                    onChange={(e) => this.props.onChangeValue(e, 'name')}
                                />
                                {nameInputError !== null
                                    ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>
                            <FormGroup controlId="formAux">
                                <ControlLabel>Descrição</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={zoneType.aux}
                                    placeholder="Introduza a descrição"
                                    onChange={(e) => this.props.onChangeValue(e, 'aux')}
                                />
                            </FormGroup>

                        </Form>
                        <ButtonToolbar>
                            <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                            <Button onClick={this.props.onHide}> CANCELAR </Button>
                        </ButtonToolbar>
                    </Modal.Body>
                </Modal >
                : null
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/zoneTypes/ZoneTypeForm.js